import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=3fc1a5e9&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=3fc1a5e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1a5e9",
  null
  
)

export default component.exports